



























import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import Hardware from './ItemHardware.vue';
import ItemList from '../common/ItemList.vue';
import FormNavigationButtons from '../common/FormNavigationButtons.vue';
import * as FORM_INTERFACE from '../interfaces/accessTicket.interface';
import * as rules from '@/modules/shared/shared/domain/rules';
@Component({
    components: {
        Hardware,
        ItemList,
        FormNavigationButtons,
    },
})
export default class StepHardware extends Vue {
    @Prop()
    oldHardwareTransfer!: FORM_INTERFACE.hardwareTransferInterface;

    @Prop({ default: {} })
    formValues!: {
        accessEquipmentDepartureTypes: {
            value: number;
            text: string;
        };
        accessEquipmentDeparturePeriodTypes: {
            value: number;
            text: string;
        };
        movementTypes: {
            value: number;
            text: string;
        };
    };

    isFormValid: boolean = true;
    hardwareTransfer: FORM_INTERFACE.hardwareTransferInterface[] = Array();
    rules: any = rules;
    $refs!: {
        form: any;
        list: any;
    };

    sendData() {
        this.updateListData();
        return { hardwareTransfer: this.hardwareTransfer };
    }

    updateListData() {
        this.hardwareTransfer = Array();
        this.$refs.list.requestData();
    }

    validateStep() {
        if (this.$refs.form.validate()) {
            this.$emit('nextStep');
        }
    }

    receiveData(data: any) {
        this.hardwareTransfer.push(data);
    }

    previousStep() {
        this.$emit('previousStep');
    }

    @Watch('oldHardwareTransfer')
    assignOldValues(
        value: FORM_INTERFACE.hardwareTransferInterface,
        oldValue: FORM_INTERFACE.hardwareTransferInterface,
    ) {
        //whoops
        // this.transferInformation = {
        //     ...this.oldHardwareTransfer.transferInformation,
        // };
        // if (oldValue.hardware == undefined) {
        //     this.$refs.list.setOldItems(this.oldHardwareTransfer.hardware);
        // }
    }
}
